export default function VideoContainer({ children, style = {} }) {
    return <div className="video-container" style={style}>{ children }</div>
}